"use client"
import { Link } from "react-router-dom"

const Blog = () => {
  const blogPosts = [
    {
      id: 1,
      title: "How to Use Shopify Scraper to Boost Your E-commerce Business",
      excerpt: "Learn how to leverage Shopify Scraper to gain competitive intelligence and grow your online store.",
      date: "May 10, 2023",
      author: "Sarah Johnson",
      category: "E-commerce Tips",
      image: "/placeholder.svg?key=7xa5z",
      slug: "how-to-use-shopify-scraper",
    },
    {
      id: 2,
      title: "10 Ways to Optimize Your Shopify Store for Higher Conversions",
      excerpt: "Discover proven strategies to increase your conversion rate and maximize sales on your Shopify store.",
      date: "April 22, 2023",
      author: "Michael Chen",
      category: "Conversion Optimization",
      image: "/placeholder.svg?key=x7pzj",
      slug: "optimize-shopify-store-conversions",
    },
    {
      id: 3,
      title: "The Ultimate Guide to Competitive Analysis for E-commerce",
      excerpt: "A comprehensive guide to analyzing your competitors and using those insights to improve your business.",
      date: "April 5, 2023",
      author: "Emily Rodriguez",
      category: "Market Research",
      image: "/placeholder.svg?key=x25ty",
      slug: "competitive-analysis-guide",
    },
    {
      id: 4,
      title: "How to Find Winning Products for Your Shopify Store",
      excerpt: "Learn effective strategies for identifying profitable products that will sell well in your niche.",
      date: "March 18, 2023",
      author: "David Wilson",
      category: "Product Sourcing",
      image: "/placeholder.svg?key=7ffsr",
      slug: "find-winning-products",
    },
    {
      id: 5,
      title: "Pricing Strategies That Drive E-commerce Growth",
      excerpt: "Explore different pricing models and strategies to maximize your profit margins and sales volume.",
      date: "March 3, 2023",
      author: "Jessica Lee",
      category: "Pricing",
      image: "/placeholder.svg?key=v0onj",
      slug: "pricing-strategies",
    },
    {
      id: 6,
      title: "How to Use Data to Make Better E-commerce Decisions",
      excerpt: "Leverage data analytics to make informed decisions that drive growth for your online store.",
      date: "February 15, 2023",
      author: "Robert Taylor",
      category: "Data Analytics",
      image: "/placeholder.svg?key=1t3b1",
      slug: "data-driven-decisions",
    },
  ]

  const categories = [
    "All Categories",
    "E-commerce Tips",
    "Conversion Optimization",
    "Market Research",
    "Product Sourcing",
    "Pricing",
    "Data Analytics",
  ]

  return (
    <div className="blog-page">
      {/* Hero Section */}
      <section className="blog-hero">
        <div className="blog-hero-container">
          <h1 className="blog-hero-title">Shopify Scraper Blog</h1>
          <p className="blog-hero-description">Insights, tips, and strategies to help you succeed in e-commerce</p>
        </div>
      </section>

      {/* Blog Content */}
      <section className="blog-content-section">
        <div className="blog-content-container">
          {/* Sidebar */}
          <div className="blog-sidebar">
            <div className="sidebar-section">
              <h3 className="sidebar-title">Categories</h3>
              <ul className="category-list">
                {categories.map((category, index) => (
                  <li key={index} className="category-item">
                    <a href="#" className="category-link">
                      {category}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="sidebar-section">
              <h3 className="sidebar-title">Recent Posts</h3>
              <ul className="recent-posts-list">
                {blogPosts.slice(0, 3).map((post) => (
                  <li key={post.id} className="recent-post-item">
                    <Link to={`/blog/${post.slug}`} className="recent-post-link">
                      {post.title}
                    </Link>
                    <span className="recent-post-date">{post.date}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="sidebar-section">
              <h3 className="sidebar-title">Subscribe</h3>
              <p className="subscribe-description">
                Get the latest articles and e-commerce tips straight to your inbox
              </p>
              <form className="subscribe-form">
                <input type="email" placeholder="Your email address" className="subscribe-input" required />
                <button type="submit" className="subscribe-button">
                  Subscribe
                </button>
              </form>
            </div>
          </div>

          {/* Blog Posts */}
          <div className="blog-posts">
            <div className="blog-posts-grid">
              {blogPosts.map((post) => (
                <div className="blog-post-card" key={post.id}>
                  <Link to={`/blog/${post.slug}`} className="post-image-link">
                    <img src={post.image || "/placeholder.svg"} alt={post.title} className="post-image" />
                  </Link>
                  <div className="post-content">
                    <div className="post-meta">
                      <span className="post-category">{post.category}</span>
                      <span className="post-date">{post.date}</span>
                    </div>
                    <h2 className="post-title">
                      <Link to={`/blog/${post.slug}`} className="post-title-link">
                        {post.title}
                      </Link>
                    </h2>
                    <p className="post-excerpt">{post.excerpt}</p>
                    <div className="post-footer">
                      <span className="post-author">By {post.author}</span>
                      <Link to={`/blog/${post.slug}`} className="read-more-link">
                        Read More →
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Pagination */}
            <div className="blog-pagination">
              <button className="pagination-button prev" disabled>
                ← Previous
              </button>
              <div className="pagination-numbers">
                <button className="pagination-number active">1</button>
                <button className="pagination-number">2</button>
                <button className="pagination-number">3</button>
              </div>
              <button className="pagination-button next">Next →</button>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="blog-cta-section">
        <div className="blog-cta-container">
          <h2 className="blog-cta-title">Ready to supercharge your e-commerce business?</h2>
          <p className="blog-cta-description">Try Shopify Scraper today and gain valuable insights into your market</p>
          <Link to="/home" className="blog-cta-button">
            Try It Now
          </Link>
        </div>
      </section>

      {/* Styling */}
      <style jsx="true">{`
        /* Blog Hero Section */
        .blog-hero {
          background-color: #007BFF;
          color: white;
          padding: 5rem 0;
          text-align: center;
        }
        
        .blog-hero-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 1.5rem;
        }
        
        .blog-hero-title {
          font-size: 2.5rem;
          font-weight: 700;
          margin-bottom: 1.5rem;
        }
        
        .blog-hero-description {
          font-size: 1.25rem;
          max-width: 800px;
          margin: 0 auto;
          opacity: 0.9;
        }
        
        /* Blog Content Section */
        .blog-content-section {
          padding: 5rem 0;
          background-color: #f9fafb;
        }
        
        .blog-content-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 1.5rem;
          display: flex;
          gap: 3rem;
        }
        
        /* Sidebar */
        .blog-sidebar {
          width: 300px;
          flex-shrink: 0;
        }
        
        .sidebar-section {
          background-color: white;
          padding: 1.5rem;
          border-radius: 0.5rem;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
          margin-bottom: 2rem;
        }
        
        .sidebar-title {
          font-size: 1.25rem;
          font-weight: 600;
          margin-bottom: 1.5rem;
          color: #1a202c;
          padding-bottom: 0.75rem;
          border-bottom: 1px solid #e5e7eb;
        }
        
        .category-list, .recent-posts-list {
          list-style: none;
          padding: 0;
        }
        
        .category-item, .recent-post-item {
          margin-bottom: 0.75rem;
        }
        
        .category-link, .recent-post-link {
          color: #4a5568;
          text-decoration: none;
          transition: color 0.2s;
          display: block;
        }
        
        .category-link:hover, .recent-post-link:hover {
          color: #007BFF;
        }
        
        .recent-post-date {
          display: block;
          font-size: 0.875rem;
          color: #6b7280;
          margin-top: 0.25rem;
        }
        
        .subscribe-description {
          margin-bottom: 1rem;
          font-size: 0.875rem;
          color: #4a5568;
        }
        
        .subscribe-form {
          display: flex;
          flex-direction: column;
          gap: 0.75rem;
        }
        
        .subscribe-input {
          padding: 0.75rem;
          border: 1px solid #e5e7eb;
          border-radius: 0.375rem;
          font-size: 0.875rem;
        }
        
        .subscribe-button {
          background-color: #007BFF;
          color: white;
          border: none;
          padding: 0.75rem;
          border-radius: 0.375rem;
          font-weight: 600;
          cursor: pointer;
          transition: background-color 0.2s;
        }
        
        .subscribe-button:hover {
          background-color: #008f85;
        }
        
        /* Blog Posts */
        .blog-posts {
          flex: 1;
        }
        
        .blog-posts-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
          gap: 2rem;
          margin-bottom: 3rem;
        }
        
        .blog-post-card {
          background-color: white;
          border-radius: 0.5rem;
          overflow: hidden;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        
        .blog-post-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
        }
        
        .post-image-link {
          display: block;
        }
        
        .post-image {
          width: 100%;
          height: 200px;
          object-fit: cover;
        }
        
        .post-content {
          padding: 1.5rem;
        }
        
        .post-meta {
          display: flex;
          justify-content: space-between;
          margin-bottom: 1rem;
          font-size: 0.875rem;
        }
        
        .post-category {
          color: #007BFF;
          font-weight: 500;
        }
        
        .post-date {
          color: #6b7280;
        }
        
        .post-title {
          font-size: 1.25rem;
          font-weight: 700;
          margin-bottom: 1rem;
          line-height: 1.4;
        }
        
        .post-title-link {
          color: #1a202c;
          text-decoration: none;
          transition: color 0.2s;
        }
        
        .post-title-link:hover {
          color: #007BFF;
        }
        
        .post-excerpt {
          color: #4a5568;
          margin-bottom: 1.5rem;
          font-size: 0.875rem;
          line-height: 1.6;
        }
        
        .post-footer {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 0.875rem;
        }
        
        .post-author {
          color: #6b7280;
        }
        
        .read-more-link {
          color: #007BFF;
          text-decoration: none;
          font-weight: 500;
          transition: color 0.2s;
        }
        
        .read-more-link:hover {
          color: #008f85;
        }
        
        /* Pagination */
        .blog-pagination {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 1rem;
        }
        
        .pagination-button {
          background-color: white;
          border: 1px solid #e5e7eb;
          padding: 0.5rem 1rem;
          border-radius: 0.375rem;
          color: #4a5568;
          cursor: pointer;
          transition: all 0.2s;
        }
        
        .pagination-button:hover:not(:disabled) {
          background-color: #f3f4f6;
          color: #1a202c;
        }
        
        .pagination-button:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
        
        .pagination-numbers {
          display: flex;
          gap: 0.5rem;
        }
        
        .pagination-number {
          width: 2.5rem;
          height: 2.5rem;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: white;
          border: 1px solid #e5e7eb;
          border-radius: 0.375rem;
          color: #4a5568;
          cursor: pointer;
          transition: all 0.2s;
        }
        
        .pagination-number:hover:not(.active) {
          background-color: #f3f4f6;
          color: #1a202c;
        }
        
        .pagination-number.active {
          background-color: #007BFF;
          color: white;
          border-color: #007BFF;
        }
        
        /* CTA Section */
        .blog-cta-section {
          padding: 5rem 0;
          background-color: #007BFF;
          color: white;
          text-align: center;
        }
        
        .blog-cta-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 1.5rem;
        }
        
        .blog-cta-title {
          font-size: 2.25rem;
          font-weight: 700;
          margin-bottom: 1rem;
        }
        
        .blog-cta-description {
          font-size: 1.125rem;
          margin-bottom: 2rem;
          opacity: 0.9;
          max-width: 800px;
          margin-left: auto;
          margin-right: auto;
        }
        
        .blog-cta-button {
          display: inline-block;
          background-color: white;
          color: #007BFF;
          font-weight: 600;
          padding: 0.75rem 2rem;
          border-radius: 0.375rem;
          text-decoration: none;
          transition: background-color 0.2s;
        }
        
        .blog-cta-button:hover {
          background-color: #f9fafb;
        }
        
        /* Responsive Styles */
        @media (max-width: 1024px) {
          .blog-content-container {
            flex-direction: column;
          }
          
          .blog-sidebar {
            width: 100%;
            margin-bottom: 3rem;
          }
          
          .sidebar-section {
            margin-bottom: 1.5rem;
          }
        }
        
        @media (max-width: 768px) {
          .blog-hero-title {
            font-size: 2rem;
          }
          
          .blog-hero-description {
            font-size: 1.125rem;
          }
          
          .blog-posts-grid {
            grid-template-columns: 1fr;
          }
          
          .blog-cta-title {
            font-size: 1.75rem;
          }
        }
      `}</style>
    </div>
  )
}

export default Blog
